import React from 'react'
import styled from 'styled-components'
import {ICON_SIZE} from 'consts/components'
import {getTextShadow} from 'utils/commons'
import {IconProps} from './IconProps'

const StyledIcon = styled.i<IconProps>`
  ${({size = ICON_SIZE, color = 'black', theme, hasShadow, hasOpacity}) => ({
    fontSize: size,
    color: color !== 'inherit' ? theme[color] : 'inherit',
    textShadow: hasShadow
      ? getTextShadow(theme, {opacity: hasOpacity ? 0.5 : undefined})
      : undefined,
  })}
  letter-spacing: 0;
  align-self: center;
`

export default function Icon({prefix = 'icon-', type, ...props}: IconProps) {
  return (
    <StyledIcon
      {...props}
      // @ts-ignore
      // This class name using from fontello
      className={`${prefix}${type}`}
      type={type}
    />
  )
}
